var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookReader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 3.81249C10.9998 2.25918 9.65669 1 7.99984 1C6.343 1 4.9999 2.25918 4.9999 3.81249C4.9999 5.36581 6.343 6.62499 7.99984 6.62499C9.65669 6.62499 10.9998 5.36581 10.9998 3.81249ZM7.29954 8.06346C5.44552 6.9994 2.44245 6.70702 0.931232 6.62645C0.423429 6.5995 0 6.96219 0 7.4201V13.9474C0 14.3673 0.36218 14.7173 0.827796 14.7399C2.19214 14.807 4.9524 15.0528 6.86018 15.9537C7.15299 16.092 7.50017 15.9036 7.50017 15.6059V8.3992C7.49985 8.26238 7.42767 8.13699 7.29954 8.06346ZM15.0685 6.62645C13.5575 6.70672 10.5542 6.9994 8.70045 8.06346C8.57233 8.13699 8.50015 8.26736 8.50015 8.40418V15.605C8.50015 15.9036 8.84826 16.0922 9.14201 15.9537C11.0495 15.0537 13.8082 14.8079 15.1722 14.7408C15.6378 14.7179 16 14.3678 16 13.948V7.4201C15.9997 6.96219 15.5763 6.5995 15.0685 6.62645Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookReader);
export default __webpack_public_path__ + "static/media/book-reader.080bd69ccfc2c5059bd8259c87b392ff.svg";
export { ForwardRef as ReactComponent };